module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Several people in Indianapolis responded graciously to my inquiries about the law, truth and custom of activities described fictitiously in this book. Discrepancies between the final product and reality are solely of my making and in no way reflect on the accuracy of what they told me or my appreciation of their efforts")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right1-1"
  }, [_c('span', [_c('i', [_vm._v("M.Z.L")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541061f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/frontmatter01.vue
// module id = 87
// module chunks = 0